// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTerms_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /lgpd_terms
 *
 * Returns a list of LGPD terms.
 */
import type { LgpdTerms_ListRow } from './LgpdTerms_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type LgpdTerms_ListResponseDados = LgpdTerms_ListRow[];

export type LgpdTerms_ListResponse = ApiResponse<LgpdTerms_ListResponseDados>;

registerResponseContract('LgpdTerms_ListResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:             { type: 'number',  required: true },
      titulo:         { type: 'string',  required: true },
      versao:         { type: 'string',  required: true },
      conteudo:       { type: 'string',  required: true },
      ativo:          { type: 'number',  required: true },
      deactivated_at: { type: 'string',  required: false },
      created_by:     { type: 'string',  required: false },
      created_at:     { type: 'string',  required: false },
      updated_at:     { type: 'string',  required: false },
    },
  },
})
